import React from 'react'
import styled from 'styled-components'
import Div100vh from 'react-div-100vh'

import background from '../assets/images/background.jpg'

import Main from './main'

interface IProps {
  children: React.ReactNode
}

export default function Layout({ children }: IProps) {
  return (
    <Container>
      <Main>{children}</Main>
    </Container>
  )
}

const Container = styled(Div100vh)`
  align-items: center;
  background: url('${background}');
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100vw;
`
